import { configureStore } from '@reduxjs/toolkit';
import worldCupResultSlice from '../features/WorldCupResultSlice';
import teamSlice from '../features/TeamSlice';

export const store = configureStore({
  reducer: {
    worldCupResult: worldCupResultSlice,
    team: teamSlice,
  },
});
